export enum ProductCardSizes {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
  ExtraSmall = 'Extra Small',
  Landscape = 'Landscape'
}
